import * as React from 'react';

import { AnimatedButton } from 'components/Map/AnimatedButton';
import styles from './SaveItineraryButton.module.css';
import { Itinerary } from 'models/itinerary';
import { useTranslation } from 'react-i18next';
import { useMapDisplayContext } from 'components/Map/MapDisplayContext';
import MapDisplayContextService from 'components/Map/MapDisplayContextService';

export const SaveItineraryButton = ({
  itinerary,
  onCloseChat,
}: {
  itinerary: Itinerary;
  onCloseChat: () => void;
}) => {
  const { t } = useTranslation();
  const { replaceUrlParams } = useMapDisplayContext();

  return (
    <AnimatedButton
      className={styles.btn}
      clickedClassName={styles.clicked}
      onClick={() => {
        MapDisplayContextService.setNewItinerary(itinerary);
        replaceUrlParams({ pg: 'ITINERARIES.EDIT', nav: 'map' });
        onCloseChat();
      }}
    >
      {t('Save this Itinerary')}
    </AnimatedButton>
  );
};
